<script setup lang="ts">
  import { useAppStore } from '#imports';

  const { isMenu } = storeToRefs(useAppStore());
</script>

<template>
    <v-footer
      class="w-100 d-flex justify-center flex-column text-center py-4"
      style="bottom: 0px; position: fixed;">
      <v-row
        class="engrave mb-4 mt-n2 rounded-pill"
        no-gutters>
        <v-btn
          color="secondary"
          density="compact"
          variant="text"
          to="/">
          Instructions
        </v-btn>
        <v-btn
          color="secondary"
          density="compact"
          variant="text"
          to="/disclaimer">
          Disclaimer
        </v-btn>
      </v-row>
      <v-col class="pa-0 ma-n2 color-secondary text-caption"
        style="opacity: 0.7;">
        ©{{ new Date().getFullYear() }} — <span class="brand-font">The Northeastern Apprenticeship and Training Program</span>
      </v-col>
    </v-footer>
  </template>